module.exports = __webpack_public_path__ + "img/logo-main-2.11be4f9b.svg";